import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';

const Tags = styled(Element)`
    font-family: Arial;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: #71929C;
`;

const TagLine = ({ element }) => {
    const player = useContext(PlayerContext);

    return (
        <Tags element={element}>{player.fieldValue(element, 'tags')}</Tags>
    );
};

export default TagLine;
